import React from "react";

const RequestModal = () => {
  return (
    <div className="flex flex-col items-center gap-6">
      <h2 className="text-black text-4xl">Request</h2>

      <input
        placeholder="Wallet Adress"
        className="w-[70%] text-xl border border-black py-3 px-3 rounded-lg"
      />
      <input
        placeholder="Amount"
        className="w-[70%] text-xl border border-black py-3 px-3 rounded-lg"
      />
      <button className="rounded-full px-12 py-2 bg-[#9a86f3] text-2xl cursor-pointer">
        Request
      </button>
    </div>
  );
};

export default RequestModal;
